import React from "react";
import { Chip } from "@mui/material";

type Level =
  | "Supervisor Master"
  | "Gestor de Contas"
  | "Conta Google (importador)"
  | "Admin"
  | "Cliente"
  | "Supervisor de Contas"
  | "Vendedor";

interface LevelChipProps {
  level: Level;
}

const levelConfig: Record<Level, { sx: React.CSSProperties }> = {
  "Supervisor Master": {
    sx: {
      backgroundColor: "#FCE8E6",
      color: "#D93025",
      fontWeight: 500,
    },
  },
  "Gestor de Contas": {
    sx: {
      backgroundColor: "#EAF1FB",
      color: "#0B4FA8",
      fontWeight: 500,
    },
  },
  "Conta Google (importador)": {
    sx: {
      backgroundColor: "#FEF7E0",
      color: "#B06000",
      fontWeight: 500,
    },
  },
  Admin: {
    sx: {
      backgroundColor: "#FCE8E6",
      color: "#C5221F",
      fontWeight: 500,
    },
  },
  Cliente: {
    sx: {
      backgroundColor: "#f1f3f4",
      color: "#5f6368",
      fontWeight: 500,
    },
  },
  "Supervisor de Contas": {
    sx: {
      backgroundColor: "#EAF1FB",
      color: "#0B4FA8",
      fontWeight: 500,
    },
  },
  Vendedor: {
    sx: {
      backgroundColor: "#EAF7EE",
      color: "#1E8E3E",
      fontWeight: 500,
    },
  },
};

export const LevelChip: React.FC<LevelChipProps> = ({ level }) => {
  const config = levelConfig[level] || { sx: {} };
  return <Chip label={level} size="small" sx={config.sx} />;
};
